if($('header').length){
    $('.responsive-tools').append($('header#header .header-top .navigation-buttons a[data-target="cart"]'))
    $('.header-top').append($('.responsive-tools'))
    $('#customerLogin input[name="email"]').attr('placeholder', '').before('<label for="email">E-mail<span>*</span></label>')
	$('#customerLogin input[name="password"]').attr('placeholder', '').before('<label for="password">Heslo<span>*</span></label>')
    $('<span class="close"></span>').appendTo('.login-widget .popup-widget-inner');    
    $(document).on("click", ".login-widget .popup-widget-inner .close", function(){
        $('body').removeClass('user-action-visible login-window-visible')
    })

    $(document).on("click", ".search .close", function(){
        $('body').removeClass('user-action-visible search-window-visible')
        $('header#header .search input.search-input').val('')
    })
    $(document).on('click', function (event) {
        var clickedElement = $(event.target);
        if (!(clickedElement.closest('.search').length || clickedElement.is('a[data-target="search"]'))) {
            $('body').removeClass('search-window-visible user-action-visible');
            $('header#header .search input.search-input').val('')
        }
        if (!(clickedElement.closest('.login-widget').length || clickedElement.is('a[data-target="login"]'))) {
            $('body').removeClass('login-window-visible user-action-visible');
        }
    });
    $('<span class="close"></span>').appendTo('.search');
    $('header#header').before($('.header-top .search').clone().addClass('customSearch'))
    $('.header-top').append($('nav#navigation').clone())
    $('.familyFirm span').html(new Date().getFullYear() - odKdyNaTrhu)
    $(document).ready(function() {
        shoptet.menu.splitMenu();
    });
    $('body').append('<div class="hidePrice"><span>Ceny</span></div>')
}


$(document).ready(function() {
    var isPriceHidden = localStorage.getItem('hidePrice');
    if (isPriceHidden === 'true') {
      $('body').addClass('price-hidden');
    }
    $('.hidePrice span').on('click', function() {
      var currentState = localStorage.getItem('hidePrice');
      var newState = (currentState === 'true') ? 'false' : 'true';
      localStorage.setItem('hidePrice', newState);
      if (newState === 'true') {
        $('body').addClass('price-hidden');
      } else {
        $('body').removeClass('price-hidden');
      }
    });
  });

